import { ProtectedRoute } from '../components/ProtectedRoute';
import MilestoneDetail from './MilestoneDetail';

export default function ProtectedMilestoneDetail() {
  return (
    <ProtectedRoute>
      <MilestoneDetail />
    </ProtectedRoute>
  );
}
